import script from "./MainBody.vue?vue&type=script&setup=true&name=MainBody&lang=js"
export * from "./MainBody.vue?vue&type=script&setup=true&name=MainBody&lang=js"

import "./MainBody.vue?vue&type=style&index=0&id=5df84d9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df84d9a"]])

export default __exports__